var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wallet)?_c(_vm.componentMap[_vm.wallet.name],{tag:"component",attrs:{"wallet":_vm.wallet,"project":_vm.project},on:{"next":_vm.onAddressSelected,"onError":_vm.onError,"cancel":_vm.cancel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }